// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Help_helpContainer__hRme5 {
  display: flex;
  flex: 1 1;
  width: 100%;
  min-height: calc(100vh - 56px);
  background-color: #f8fafc;
  overflow-y: auto;
}

.Help_contentWrapper__IjKwD {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1.5rem 4rem 1.5rem;
  gap: 2.5rem;
}
@media (max-width: 768px) {
  .Help_contentWrapper__IjKwD {
    padding: 1.25rem 1rem 3rem 1rem;
    gap: 1.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Help/Help.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;EACA,WAAA;AACF;AACE;EAVF;IAWI,+BAAA;IACA,YAAA;EAEF;AACF","sourcesContent":[".helpContainer {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  min-height: calc(100vh - 56px);\n  background-color: #f8fafc;\n  overflow-y: auto;\n}\n\n.contentWrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 1.5rem 4rem 1.5rem;\n  gap: 2.5rem;\n\n  @media (max-width: 768px) {\n    padding: 1.25rem 1rem 3rem 1rem;\n    gap: 1.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpContainer": `Help_helpContainer__hRme5`,
	"contentWrapper": `Help_contentWrapper__IjKwD`
};
export default ___CSS_LOADER_EXPORT___;
